<bn-loading-overlay></bn-loading-overlay>
<div class="container mt-3 mx-auto">
  <div class="row">
    <div class="col">
      <h5>Conglomerado ({{novoConglomerado ? 'cadastro' : 'edição'}})</h5>
    </div>
    <div class="col-auto">
      <button
        type="button"
        class="btn btn-danger"
        *ngIf="edicaoHabilitada"
        (click)="abrirConfirmacaCancelar()">
        Cancelar
      </button>

      <button type="button" class="btn btn-primary" (click)="salvar()" *ngIf="podeSalvar()"
          >Salvar
      </button>

      <button ngbTooltip="Retorna a tela anterior" type="button" class="btn btn-primary" (click)="irParaPesquisa()" *ngIf="!novoConglomerado && !edicaoHabilitada"
          >Voltar
      </button>

      <button
        ngbTooltip="Inativar conglomerado" type="button" class="btn btn-danger" (click)="abrirConfirmacao()" *ngIf="!novoConglomerado && !edicaoHabilitada && podeEditar()"
        >Inativar
      </button>

      <button [ngbTooltip]="tipoConglomeradoDiferenteDaConfigModalidade ? 'Edição desabilitada, pois conglomerado criado com calculo do percentual diferente da configuração da Modalidade Garantia' : 'Habilita edição do conglomerado'" type="button" class="btn btn-success"
          (click)="habilitarEdicao()"
          *ngIf="!novoConglomerado && !edicaoHabilitada && podeEditar()"
          [disabled]="tipoConglomeradoDiferenteDaConfigModalidade">
          Editar
      </button>
    </div>
  </div>

  <form [formGroup]="conglomeradoForm">
    <div class="row">
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="codigo-conglomerado">Código do conglomerado:</label>
        <input id="codigo-conglomerado" class="form-control" readonly [value]="conglomerado?.codigo | numeroConglomerado">
      </div>
    </div>
    <div class="row" *ngIf="novoConglomerado || edicaoHabilitada">
      <div class="bn-form-group col-md-4">
        <label class="form-label" for="agenteFinanceiro">Agente Financeiro:</label>
        <select id="agenteFinanceiro" class="form-select" formControlName="agenteFinanceiro"
          (ngModelChange)="selecionar($event)">
          <option [ngValue]="null"></option>
          <option [disabled]="desabilitaOpcao(agente)" *ngFor="let agente of agentesFinanceiros" [ngValue]="agente">
            {{ agente.nome }} [{{ agente.cnpj | bnCnpj }}]
          </option>
        </select>
      </div>
      <div class="bn-form-group col-md-3" *ngIf="agenteFinanceiroSelecionado != null">
        <label class="form-label" for="cnpj-cotista">CNPJ</label>
        <input id="cnpj-cotista" class="form-control" readonly [value]="agenteFinanceiroSelecionado?.cnpj | bnCnpj">
      </div>
      <div class="bn-form-group col-md-2" *ngIf="agenteFinanceiroSelecionado != null && conglomeradoComPercentualManual">
        <label class="form-label" for="percentual"> <span ngbTooltip="Percentual de participação no conglomerado">Percentual %</span> </label>
        <input id="percentual" class="form-control" bnMask="DECIMAL" [casasDecimais]="2" maxlength="5" formControlName="percentual">
      </div>
      <div class="bn-form-group col-md-3" *ngIf="agenteFinanceiroSelecionado != null"
        style="display: flex;justify-content: flex-end;align-items: flex-start;flex-direction: column; flex-basis: max-content;">
        <button type="submit" class="btn btn-primary no-margin" (click)="incluirNoConglomerado()"
          >Incluir Conglomerado
      </button>
      </div>
    </div>

    <div class="table-responsive" *ngIf="conglomerado?.participanteConglomerado.length != 0">
      <table class="table">
        <thead>
          <th>Agente Financeiro</th>
          <th>CNPJ</th>
          <th *ngIf="!conglomeradoComPercentualManual">Valor Subscrição R$</th>
          <th>Percentual %</th>
          <th *ngIf="!novoConglomerado">Data Inicio</th>
          <th *ngIf="!novoConglomerado">Data Final</th>
          <th>Ações</th>
        </thead>
        <tbody>
          <tr *ngFor="let item of conglomerado?.participanteConglomerado; let indexItem = index" [ngClass]="( item?.dataFinal != null ? 'fundo-inativo' : '')">
            <td>{{ item.agenteFinanceiro.nome }}</td>
            <td>{{ item.agenteFinanceiro.cnpj | bnCnpj}}</td>
            <td *ngIf="!conglomeradoComPercentualManual">{{ item.valorTotal | bnMask: 'MOEDA' }}</td>
            <td><span ngbTooltip="Percentual de participação no conglomerado">{{ item.percentual | percent: '2.2-4' }}</span></td>
            <td *ngIf="!novoConglomerado">{{item.dataInicial | date: 'dd/MM/yyyy'}}</td>
            <td *ngIf="!novoConglomerado">{{item.dataFinal | date: 'dd/MM/yyyy'}}</td>
            <td>
              <a
              href="javascript:void(0)"
              *ngIf="novoConglomerado || edicaoHabilitada"
				      (click)="remover(indexItem)">
              <i class="fa fa-trash cursor-pointer margin-left-5" placement="left-top" ngbTooltip="Excluir Conglomerado"></i>
            </a>
            </td>
          </tr>
          <tr *ngIf="conglomeradoComPercentualManual && (edicaoHabilitada || novoConglomerado)">
            <td colspan="2"><b>Total</b></td>
            <td colspan="2">
              {{ getPercentualMostrar() | percent: '2.2-4' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-template #msgTemplateInativar>
      <span
        >Esta ação irá inativar todo o Conglomerado. </span>
      <br />
      <br />
      Você confirma?
      <br />
    </ng-template>
    <ng-template #botoesPersonalizadosInativar>
      <button class="btn btn-md btn-success" (click)="inativar()">
        Sim
      </button>
      <button class="btn btn-md btn-danger" (click)="dismissModal()">
        Não
      </button>
    </ng-template>

    <ng-template #msgTemplateCancelar>
      <span >Descartar {{novoConglomerado ? 'novo cadastro de' : 'edição do'}}  Conglomerado?</span>
      <br />
    </ng-template>
    <ng-template #botoesPersonalizadosCancelar>
      <button class="btn btn-md btn-success" (click)="cancelar()">
        Sim
      </button>
      <button class="btn btn-md btn-danger" (click)="dismissModal()">
        Não
      </button>
    </ng-template>
  </form>
</div>
